module.exports = __webpack_public_path__ + "img/venice.b0e51e0b.jpg";